import React, { Fragment } from 'react'
import classnames from 'classnames'

import GreenTick from '../../../assets/img/green_tick.png'

const Step = props => {
  const {
    step,
    title,
    subtitle,
    showAction,
    actionLabel,
    onActionClick,
    disabled,
    completed,
    active,
    children
  } = props

  return (
    <div
      className={classnames('step', {
        disabled,
        completed,
        active
      })}>
      <div className="header">
        <div className="header_col">
          <div className="badge">
            {completed ? (
              <img src={GreenTick} alt="completed" />
            ) : (
              <span>{step}</span>
            )}
          </div>
          <div className="title">
            <span>{title}</span>
          </div>
        </div>

        <div className="header_col">
          <div className="subtitle_container">
            {typeof subtitle === 'string' && (
              <span className="subtitle">{subtitle}</span>
            )}
            {showAction && (
              <Fragment>
                {' '}
                <span className="action_label" onClick={onActionClick}>
                  {actionLabel}
                </span>
              </Fragment>
            )}
          </div>
        </div>
      </div>

      {active && children && <div className="content">{children}</div>}
    </div>
  )
}

export default Step



// WEBPACK FOOTER //
// ./src/modules/Checkout/components/Step.jsx